import { render, staticRenderFns } from "./AdminCategoryTypeAddModal.vue?vue&type=template&id=2a67a498"
import script from "./AdminCategoryTypeAddModal.vue?vue&type=script&lang=js"
export * from "./AdminCategoryTypeAddModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gl-apistage/apistage.greenlists.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a67a498')) {
      api.createRecord('2a67a498', component.options)
    } else {
      api.reload('2a67a498', component.options)
    }
    module.hot.accept("./AdminCategoryTypeAddModal.vue?vue&type=template&id=2a67a498", function () {
      api.rerender('2a67a498', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/AdminCategoryTypeAddModal.vue"
export default component.exports